// Core imports
import React, { Fragment, useEffect, useMemo } from 'react';
import PropTypes from 'prop-types';
import { t } from 'i18next';

// Component Imports
import { Card, Col, Row } from 'antd';
import DecisionTreesUsageSection from './DecisionTreesUsageSection';

// Misc imports
import { ANALYTICS_SECTIONS } from '../../constants/main';
import { useFetchDecisionTreesAnalyticsQuery } from '../../store/analytics/analyticsApi';
import { isEmptyArray } from '../../utils/is/isEmptyArray';

const AnalyticsDecisionTreesTab = ({
  requestParams,
  isPublicMode,
  setIsLoading = () => false
}) => {

  const { data: decisionTreesAnalytics, isFetching: isFetchingDecisionTreesAnalytics, isUninitialized } = useFetchDecisionTreesAnalyticsQuery({ ...requestParams?.[0] }, { skip: isEmptyArray(requestParams) });

  // Memoize loading state to prevent unnecessary re-renders
  const isLoading = useMemo(() =>
    isFetchingDecisionTreesAnalytics || isUninitialized,
  [isFetchingDecisionTreesAnalytics, isUninitialized]
  );

  useEffect(() => {
    setIsLoading(isLoading);

    return () => {
      setIsLoading(false);
    };
  }, [isLoading]);

  const renderDecisionTreesSection = () => {
    return (
      <Fragment>
        <Row gutter={[16, 16]} className="mb-5 hide-empty" id={`analytics-section_${ANALYTICS_SECTIONS.DECISION_TREES.key}`}>
          <Col xs={24} md={12} xxl={12} id={`analytics-section_${ANALYTICS_SECTIONS.DECISION_TREES.key}_${ANALYTICS_SECTIONS.DECISION_TREES.subSections.USAGE.key}`}>
            <Card className="h-100">
              <DecisionTreesUsageSection
                data={decisionTreesAnalytics?.usage}
                isLoading={isLoading}
                seriesName={t('Generic')}
                sectionTitle={t('Usage')}
              />
            </Card>
          </Col>
        </Row>
      </Fragment>
    );
  };

  return (
    <Fragment>
      { renderDecisionTreesSection() }
    </Fragment>
  );
};

AnalyticsDecisionTreesTab.propTypes = {
  requestParams: PropTypes.array,
  isPublicMode: PropTypes.bool,
  setIsLoading: PropTypes.func
};

export default AnalyticsDecisionTreesTab;
